import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../configuration/setup/store';

export const selectTokenHandling = (state: RootState) => state.tokenHandling;
export const selectIdToken = createSelector(selectTokenHandling, (state) => state.idToken);
export const selectAccessToken = createSelector(
    selectTokenHandling,
    (state) => state.accessToken ?? 'NO_ACCESS_TOKEN_AVAILABLE',
);
